export function welcomePopup() {
    const welcomePopup = document.querySelector('.welcome-popup');

    if (document.cookie.indexOf("cookieSiteVisited=") >= 0) {
        welcomePopup.style.display = 'none';
    } else {
        welcomePopup.style.display = 'flex';
    }

    function hidewelcomePopup() {
        let expiry = new Date();
        expiry.setMonth(expiry.getMonth() + 1);
        document.cookie = "cookieSiteVisited=yes; path=/; expires=" + expiry.toGMTString();
        welcomePopup.style.display = 'none';
    }

    welcomePopup.addEventListener("click", function (e) {
        e.preventDefault();
        hidewelcomePopup();
    });

    window.addEventListener('load', function () {
        setTimeout(function () {
            hidewelcomePopup();
        }, 8000);
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/welcomePopup.js